import React, { useContext, useState } from 'react';
import Form from '../../..';
import * as S from './styled';
import DateFilter from '../../../../DateFilter';
import { setFilterColumn } from '../../../../../store/utils';
import { ExportContext } from '../../../../../provider/ExportProvider';

export default function FormInvoiceFilter() {
  const {
    getAutocompleteItems,
    setAutocompleteItems,
    getFilterField,
    setField,
    setSearchFilter,
    searchFilter,
    setInvoice,
    setFilterField,
    labels,
    situations,
    locks,
    invoiceGroups,
    selectedGroupId,
  } = useContext(ExportContext)!.controllers.invoice;

  const getItems = (field: keyof InvoiceState['autocompletes']['invoices']) =>
    getAutocompleteItems(field);

  const [productLoading, setProductLoading] = useState(false);
  const [companyLoading, setCompanyLoading] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);
  const [invoiceNumberLoading, setInvoiceNumberLoading] = useState(false);
  const [crtLoading, setCrtLoading] = useState(false);

  const autocompleteProducts = () => {
    setProductLoading(true);
    setAutocompleteItems('product').finally(() => {
      setProductLoading(false);
    });
  };

  const autocompleteCompanies = () => {
    setCompanyLoading(true);
    setAutocompleteItems('company').finally(() => {
      setCompanyLoading(false);
    });
  };

  const autocompleteGroups = () => {
    setGroupLoading(true);
    setAutocompleteItems('group').finally(() => {
      setGroupLoading(false);
    });
  };

  const autocompleteInvoiceNumbers = () => {
    setInvoiceNumberLoading(true);
    setAutocompleteItems('invoiceNumber').finally(() => {
      setInvoiceNumberLoading(false);
    });
  };

  const autocompleteCrts = () => {
    setCrtLoading(true);
    setAutocompleteItems('crt').finally(() => {
      setCrtLoading(false);
    });
  };
  const lockedFilter = getFilterField('locked');
  const situationFilter = getFilterField('status');
  const labeledFilter = getFilterField('labeled');

  const [lockLabel, setLockLabel] = useState(
    locks.find(({ data }) => data === lockedFilter)?.name ?? '',
  );
  const [situationLabel, setSituationLabel] = useState(
    situations.find(({ data }) => data === situationFilter)?.name ?? '',
  );
  const [labeledLabel, setLabeledLabel] = useState(
    labels.find(({ data }) => data === labeledFilter)?.name ?? '',
  );

  return (
    <S.Form>
      <S.Body>
        <S.BodyContainer>
          {!selectedGroupId && (invoiceGroups.length > 1) ? (
            <S.Field>
              <Form.Input.Dropdown
                label="Grupo"
                value={getFilterField('group') as string}
                onChange={setField('group')}
                items={getItems('group')}
                errorMessage={false}
                onSelected={(item) => {
                  setField('group')({
                    target: {
                      value: `${item.name}`,
                    },
                  });
                }}
                onDebouncedChange={autocompleteGroups}
                onFocus={() => {
                  setField('group')({
                    target: {
                      value: '',
                    },
                  });
                }}
                hasClearItem
                loading={groupLoading}
              />
            </S.Field>
          ) : null}

          <S.Field>
            <Form.Input.Dropdown
              label="Produto"
              value={getFilterField('product') as string}
              onChange={setField('product')}
              items={getItems('product')}
              errorMessage={false}
              onSelected={(item) => {
                setField('product')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteProducts}
              onFocus={() => {
                setField('product')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={productLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Companhia"
              value={getFilterField('company') as string}
              onChange={setField('company')}
              items={getItems('company')}
              errorMessage={false}
              onSelected={(item) => {
                setField('company')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteCompanies}
              onFocus={() => {
                setField('company')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={companyLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Nota"
              value={getFilterField('invoiceNumber') as string}
              onChange={setField('invoiceNumber')}
              items={getItems('invoiceNumber')}
              errorMessage={false}
              onSelected={(item) => {
                setField('invoiceNumber')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteInvoiceNumbers}
              onFocus={() => {
                setField('invoiceNumber')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={invoiceNumberLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="CRT"
              value={getFilterField('crt') as string}
              onChange={setField('crt')}
              items={getItems('crt')}
              errorMessage={false}
              onSelected={(item) => {
                setField('crt')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteCrts}
              onFocus={() => {
                setField('crt')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={crtLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Situação"
              value={situationLabel}
              onChange={(e) => {
                const value = e.target.value;
                setSituationLabel(value);
              }}
              items={situations}
              onSelected={(item) => {
                setFilterField(
                  'status',
                  'LIKE',
                )({
                  target: {
                    value: item.data,
                  },
                });
              }}
              onBlur={() => {
                setSituationLabel(
                  situations.find(({ data }) => data === situationFilter)
                    ?.name ?? '',
                );
              }}
              errorMessage={false}
              hasClearItem
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Etiquetado"
              value={labeledLabel}
              onChange={(e) => {
                const value = e.target.value;
                setLabeledLabel(value);
              }}
              items={labels}
              onSelected={(item) => {
                setFilterField(
                  'labeled',
                  'EQUAL',
                )({
                  target: {
                    value: item.data,
                  },
                });
              }}
              onBlur={() => {
                setLabeledLabel(
                  labels.find(({ data }) => data === labeledFilter)?.name ?? '',
                );
              }}
              errorMessage={false}
              hasClearItem
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Status"
              value={lockLabel}
              errorMessage={false}
              onChange={(e) => {
                const value = e.target.value;
                setLockLabel(value);
              }}
              items={locks}
              onSelected={(item) => {
                setFilterField(
                  'locked',
                  'EQUAL',
                )({
                  target: {
                    value: item.data,
                  },
                });
              }}
              onBlur={() => {
                setLockLabel(
                  locks.find(({ data }) => data === lockedFilter)?.name ?? '',
                );
              }}
              hasClearItem
            />
          </S.Field>

          <S.DateContainer>
            <S.Label>Data</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('date', 'GEQ') as string}
                onChange={setField('date', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('date', 'LT') as string}
                onChange={setField('date', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('date', 'GEQ') as string}
              finalDate={getFilterField('date', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'date',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('date', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de criação</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('createdAt', 'GEQ') as string}
                onChange={setField('createdAt', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('createdAt', 'LT') as string}
                onChange={setField('createdAt', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('createdAt', 'GEQ') as string}
              finalDate={getFilterField('createdAt', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'createdAt',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('createdAt', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de atualização</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('updatedAt', 'GEQ') as string}
                onChange={setField('updatedAt', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('updatedAt', 'LT') as string}
                onChange={setField('updatedAt', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('updatedAt', 'GEQ') as string}
              finalDate={getFilterField('updatedAt', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'updatedAt',
                  initialDate,
                  searchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('updatedAt', finalDate, filter, 'LT');
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>
        </S.BodyContainer>
      </S.Body>

      <S.ClearButton
        onClick={(e) => {
          e.preventDefault();
          setInvoice('filters.invoices.filter.filter', []);
          setLabeledLabel('');
          setLockLabel('');
          setSituationLabel('');
        }}
      >
        Limpar
      </S.ClearButton>
    </S.Form>
  );
}
